import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

import { SkeletonComponent } from '@frontend/sports/common/ui/skeleton';

@Component({
    selector: 'ms-event-carousel-skeleton',
    templateUrl: 'event-carousel-skeleton.component.html',
    styleUrl: 'event-carousel-skeleton.component.scss',
    imports: [SkeletonComponent, NgTemplateOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventCarouselSkeletonComponent {
    @HostBinding('class') class = 'event-carousel-skeleton';
}
